const getWidthOfElement = element => element && element.offsetWidth;

export default getWidthOfElement;
